// points
function points1() {
  var points1 = $('.points-1-js');
  var points1Length = points1.length;
  var points1Index = 0;

  pointsLoopClasses();
  var points1Over = false;
  points1.hover(
    function () {
      points1Over = true;
      points1.removeClass('is-active');
      points1Index = $(this).data('index');
    },
    function () {
      points1Over = false;
      pointsLoopClasses();
    }
  );

  function pointsLoopClasses(direction) {
    points1.removeClass('is-active');
    if (points1Over) {
      return;
    }

    var element = $('#points-1-js-' + points1Index);

    element.addClass('is-active');

    if (direction !== 1) {
      if (points1Index >= points1Length - 1) {
        points1Index = 0;
      } else {
        points1Index++;
      }
    }
  }

  setInterval(pointsLoopClasses, 10000);
}

function points2() {
  var points2 = $('.points-2-js');
  var points2Length = points2.length;
  var points2Index = 0;

  pointsLoopClasses();
  var points2Over = false;
  points2.hover(
    function () {
      points2Over = true;
      points2.removeClass('is-active');
      points2Index = $(this).data('index');
    },
    function () {
      points2Over = false;
      pointsLoopClasses();
    }
  );

  function pointsLoopClasses(direction) {
    points2.removeClass('is-active');
    if (points2Over) {
      return;
    }

    var element = $('#points-2-js-' + points2Index);

    element.addClass('is-active');

    if (direction !== 1) {
      if (points2Index >= points2Length - 1) {
        points2Index = 0;
      } else {
        points2Index++;
      }
    }
  }

  setInterval(pointsLoopClasses, 10000);
}

function points3() {
  var points3 = $('.points-3-js');
  var points3Length = points3.length;
  var points3Index = 0;

  pointsLoopClasses();
  var points3Over = false;
  points3.hover(
    function () {
      points3Over = true;
      points3.removeClass('is-active');
      points3Index = $(this).data('index');
    },
    function () {
      points3Over = false;
      pointsLoopClasses();
    }
  );

  function pointsLoopClasses(direction) {
    points3.removeClass('is-active');
    if (points3Over) {
      return;
    }

    var element = $('#points-3-js-' + points3Index);

    element.addClass('is-active');

    if (direction !== 1) {
      if (points3Index >= points3Length - 1) {
        points3Index = 0;
      } else {
        points3Index++;
      }
    }
  }

  setInterval(pointsLoopClasses, 10000);
}

function points4() {
  var points4 = $('.points-4-js');
  var points4Length = points4.length;
  var points4Index = 0;

  pointsLoopClasses();
  var points4Over = false;
  points4.hover(
    function () {
      points4Over = true;
      points4.removeClass('is-active');
      points4Index = $(this).data('index');
    },
    function () {
      points4Over = false;
      pointsLoopClasses();
    }
  );

  function pointsLoopClasses(direction) {
    points4.removeClass('is-active');
    if (points4Over) {
      return;
    }

    var element = $('#points-4-js-' + points4Index);

    element.addClass('is-active');

    if (direction !== 1) {
      if (points4Index >= points4Length - 1) {
        points4Index = 0;
      } else {
        points4Index++;
      }
    }
  }

  setInterval(pointsLoopClasses, 10000);
}
